import { MembershipTier, TRIAL } from './maverick';

// Images
export const ONE_LOGO =
  'https://images.ctfassets.net/am71vbtj0o80/fNCRfwgvk8XKFqS83cXVz/bad14cb918e2bf6f9b79d94e507a8391/One_logo.svg';
export const PEAK_LOGO =
  'https://images.ctfassets.net/am71vbtj0o80/67RghdrNxJFYsDStAByfAQ/3aa82d392441dfa3283c3dc918baf5ca/Peak_logo.svg';
export const LIFE_LOGO =
  'https://images.ctfassets.net/am71vbtj0o80/4fb1Dipd6uCck4I47iua6J/5650c9ba6d6fd2e760d5f55ccc6da5bb/Life_logo.svg';

export const TRIAL_LOGO =
  'https://images.ctfassets.net/am71vbtj0o80/3anDkYI2g2QXGtmLaTEIE8/89f407db2319501f456a8ea8684f325e/FREE_TRIAL.svg';

export const ONE_APP_BAND =
  'https://images.ctfassets.net/am71vbtj0o80/4sYWjTb3b8ns7oeUqcCY5z/13f38f71d455460b552db6b5c0cd77b4/one-card.webp';
export const PEAK_APP_BAND =
  'https://images.ctfassets.net/am71vbtj0o80/2yfKcoJ6TvITb6kmgpnwzF/55d771498a9a9451076909ae3b55aeed/peak-card.webp';
export const LIFE_APP_BAND =
  'https://images.ctfassets.net/am71vbtj0o80/62iym2ntyj6eM9HVcan32P/d194f9c6f230a50dc3a120a0c5d4aa91/Life_card.png';

export const GEN_4_DEVICE_IMAGE =
  'https://images.ctfassets.net/am71vbtj0o80/bNwggMCzSWesN2CA6ZtYU/a989fe198e0954d724bfc61e37d5a17e/free-trials-band.webp';
export const GOOSE_WHATS_INCLUDED =
  'https://images.ctfassets.net/am71vbtj0o80/7hLPPvxT8us4Oq9blkDqyU/0590823f2c4114f44747847b9367f17e/Peak_what-s_in_the_box.png';

export const UPCYCLE_DESKTOP =
  'https://images.ctfassets.net/am71vbtj0o80/54wwmL6BkvHq0xP3mN8Vxz/732b66aff6fad931159c3ae949fb37c1/UpcycleImage.webp';
export const RAF_IMAGE =
  'https://images.ctfassets.net/am71vbtj0o80/6jjJHyfMYLD5RRgbghEiSm/d3621dfee2bb08c8d178ae047346b2fa/RAF.webp';

export const HARVARD_TRIAL_IMAGE =
  'https://images.ctfassets.net/am71vbtj0o80/5V0x0OtXFaM13wBRocCfMA/7a8df305cf5ba16ce0fbc1844d67c53a/1.png';
export const GOOSE_TRIAL_IMAGE =
  'https://images.ctfassets.net/am71vbtj0o80/5LOLyIWfVIv1kdbNfJvkqc/955f8834cd5a029665f4915600149d83/5.0_Trials_bento__1_.png';

export const ADVANCED_LABS_RAF_IMAGE =
  'https://images.ctfassets.net/am71vbtj0o80/4s40uj7hxRPsJFWsnM7T1K/f994e549ee1ded6279225ccffe8f4a33/Background_Images_-_intro.png';

export const tierLogoMap = {
  [MembershipTier.ONE]: ONE_LOGO,
  [MembershipTier.PEAK]: PEAK_LOGO,
  [MembershipTier.LIFE]: LIFE_LOGO,
  [TRIAL]: TRIAL_LOGO,
};

//Images for MembershipCards
export const tierHeaderImage = {
  [MembershipTier.ONE]: ONE_APP_BAND,
  [MembershipTier.PEAK]: PEAK_APP_BAND,
  [MembershipTier.LIFE]: LIFE_APP_BAND,
};

export const WHOOP_ADVANCED_LABS_IMAGE =
  'https://images.ctfassets.net/am71vbtj0o80/5RH6oHvv44kiBKSZNz8neJ/19e37f3023fee94d5fbf122f31b3bae3/advanced-labs.webp';
